import React, { useEffect, useState } from 'react'
import { useDispatch } from "react-redux";
import { makeStyles, Box, Container, Grid, Typography, Button } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { startAlerta } from "../../../actions/ui/alertas";
import { finishSpinner, startSpinner } from "../../../actions/ui/spinner";
import AfiliadoTurnosService from "../../../services/AfiliadoTurnosService";

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%'
    },
    btnConfirm: {
        marginTop: "1rem",
        textTransform:"none"
    },
    title: {
        fontWeight: "bold"
    }
}));
export const EstadoTurnoScreen = () => {
    const dispatch = useDispatch();
    const classes = useStyles()

    const { idAgenda } = useParams();
    const [ turno, setTurno ] = useState(null)

    const fetchEstadoTurno = async() => {
        try {
            dispatch(startSpinner())
            const result = await AfiliadoTurnosService.getDetalleTurno(idAgenda)
            const body = await result.json()

            if (result.ok) {
                const estadoTurno = !body.idAfiliado && !body.ididAfiliadoExterno
                                        ? {titulo: 'Turno Libre', descripcion: 'El siguiente turno se encuentra sin asignar', motivo: ''}
                                        : !body.pagoTic_EstadoPago
                                            ? {titulo: 'Turno Pendiente de Pago', descripcion: 'El siguiente turno se encuentra pendiente de pago', motivo: ''}
                                            : body?.pagoTic_EstadoPago?.status === 'rejected'
                                                ? {titulo: 'Pago Rechazado', descripcion: 'Se rechazo el pago del turno', motivo: body?.pagoTic_EstadoPago?.status_detail}
                                                : body?.pagoTic_EstadoPago?.status === 'approved'
                                                    ? {titulo: 'Turno Abonado Correctamente', descripcion: 'Se realizo con exito el pago del siguiente turno', motivo: ''}
                                                    : {titulo: 'Turno', descripcion: '', motivo: ''}
                setTurno({...body, estadoTurno});
                dispatch(finishSpinner())
            } else {
                throw body.errores
            }
        } catch (error) {
            dispatch(finishSpinner())
            if (error.mensaje) {
                dispatch(startAlerta(error.mensaje, "error"))
            } else {
                dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente", "error"))
            }
            console.log("Error al traer los datos del turno", error)
        }
    }

    useEffect(async () => {
        await fetchEstadoTurno();
    }, [dispatch, idAgenda])

    return (
        <div className={classes.root}>
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="center"
                style={{marginTop: -50}}
            >
                <Container maxWidth="sm">
                    <Box p="1rem">                        
                        <Typography align="center" variant="h4" className={classes.title} color="secondary">
                            {turno?.estadoTurno?.titulo}
                        </Typography>

                        <Typography variant="body2" align="justify" style={{marginTop: "1rem", marginBottom: "1rem", fontSize: "1rem"}}>
                            {turno?.estadoTurno?.descripcion}                            
                            {turno?.estadoTurno?.motivo !== '' &&
                                <>
                                    <br/>
                                    <b>Motivo Rechazo: {turno?.estadoTurno?.motivo}</b>
                                </>
                            }
                        </Typography>

                        {turno&&
                            <>
                                <Grid container justify="center" spacing={0}>
                                    <Grid item xs={10}>
                                        <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                            <strong>Afiliado: </strong>{turno.idAfiliado 
                                                ? turno.afiliado?.apellido_y_nombre
                                                : turno.afiliadoExterno?.apellidoNombre
                                            }
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container justify="center" spacing={0} >
                                    <Grid item xs={5}>
                                        <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                            <strong>Fecha: </strong>{new Date(turno.fecha).toLocaleString("es", optionsfecha)}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                            <strong>Hora: </strong>{turno.hora}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container justify="center" spacing={1}>
                                    <Grid item xs={10}>
                                        <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                            <strong>Profesional: </strong>{turno.efectorRed.nombreEfector}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container justify="center" spacing={1}>
                                    <Grid item xs={10}>
                                        <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                            <strong>Especialidad: </strong>{turno.especialidad.descripcionEspecialidades}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                {turno.idTipoTurnoSol &&
                                    <Grid container justify="center" spacing={1}>
                                        <Grid item xs={10}>
                                            <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                                <strong>Modalidad: </strong>{turno.idTipoTurnoSol === 1 
                                                    ? 'Presencial' 
                                                    : 'Virtual'
                                                }
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                }
                                <Grid container justify="center" spacing={1}>
                                    <Grid item xs={10}>
                                        <Typography variant="h6" class="typografy" style={{margin: "5px", marginBottom: "0px"}}>
                                            <strong>Centro Medico: </strong>{turno.centroMedico.descripcionCentro}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                {turno.idTipoTurnoSol === 1 &&
                                    <Grid container justify="center" spacing={1} style={{marginBottom: 10}}>
                                        <Grid item xs={10}>
                                            <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                                <strong>Domicilio: </strong>{turno.centroMedico.direccion}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                }
                                {
                                    <Grid container spacing={1} justifyContent='center'>
                                        <Grid item xs={12} style={{textAlign: 'center'}}>
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                style={{marginTop: 30}}
                                                onClick={fetchEstadoTurno}
                                                disabled={turno?.pagoTic_EstadoPago?.status === 'approved'}
                                            > Consultar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                }
                            </>
                        }
                    </Box>
                </Container>
            </Box>
        </div>
    );
};